import React, { useEffect, useReducer, useRef, useState } from 'react'
import MyAppBar from '../MyAppBar'


import ToneSound from '../ToneSound'
import { notesToChord } from '../util/ToneUtils'
import BackingTrackEditor from './BackingTrackEditor'
import BackingTrackGeneratorEditorContext from './editorStore/BackingTrackGeneratorEditorContext'
// import BackingTrackGeneratorSectionsContext from './sectionsStore/BackingTrackGeneratorSectionsContext'
import MainControls from './mainControls/MainControls'

import createScribbleUtils from './../util/createScribbleUtils'
import { initialEditorState } from './editorStore/backingTrackGeneratorEditorState'
import backingTrackGeneratorEditorReducer from './editorStore/backingTrackGeneratorEditorReducer'
import { EditorActionType } from './editorStore/backingTrackGeneratorEditorActions'
import { DRAG_TIMEOUT } from '../util/constants'
// import backingTrackGeneratorSectionsReducer from './sectionsStore/backingTrackGeneratorSectionsReducer'
// import { initialSectionsState } from './sectionsStore/backingTrackGeneratorSectionsState'
// import { SectionsActionType } from './sectionsStore/backingTrackGeneratorSectionsActions'

let scribbleUtils: any = null

// IDEA : VSCode ext : would be useful to have suffix syntax like this to generate more complex pattern
// TODO : enable notes in vscode ext

const matchBrackets = (str: string) => {
	let count = 0
	
	const matches = []
	
	let startIndex = null
	for (let i = 0; i < str.length; i++) {
		
		if (str[i] === '[') {
			if (count === 0) {
				startIndex = i
			}
			count++
		}
		else if (str[i] === ']') {
			count--
			if (startIndex !== null && count === 0) {
				matches.push([startIndex, i])
			}
		}
	}
	
	return matches
}

// notes: chords or note in string format
const notesToClip = (pattern: string, notes: string[], prevNote: string = '_') => {
	const notesPattern: any = []
	
	let pattern2 = ''

	let currentNote = prevNote
	
	const matches = matchBrackets(pattern)
	
	// console.log({ matches })
	
	let curr = 0
	for (let i = 0; i < notes.length; i++) {
		
		if (notes[i] !== '_') {
			currentNote = notes[i]
		}
		
		// console.log({ currentNote: notes[currentNoteIndex], curr, notesPattern: notesPattern.join(' ') })

		const match = matches.find(m => m[0] === curr)
		
		const beat = match ? pattern.slice(match[0], match[1] + 1) : pattern[curr]

		if (currentNote !== '-' && currentNote !== '_') {
			
			// console.log({ beat })
			
			const notesByBeat = (beat.match(/x/g) || []).length
			
			for (let i = 0; i < notesByBeat; i++) {
				notesPattern.push(currentNote)
			}
			
		}

		pattern2 += currentNote === '-' || currentNote === '_' ? '-' : beat
		
		curr += match ? match[1] - match[0] + 1 : 1
	}

	console.log({ pattern2 })
	
	return notesPattern.length > 0 ? {// TODO add custom octave
		notes: notesPattern.map((note: string) => note + '-3').join(' '),
		pattern: pattern2
	} : undefined
}

const patternToBarPattern = (pattern: string, signatureTimeUpper: number = 4) => {
	// TODO
	
	return pattern
}


const chordsToChordsString = (chords: any[]) => chords.map((chord: any) => typeof chord !== 'string' ? chord.currentName : chord)

// TODO : add style preset (instrument + pattern)[]
const generateBackingTrack = (sections: any[], pattern: string) => {

	console.log({ sections })
	
	const clips: any = []
	let channelPattern = ''
	
	let barCount = 0

	let prevChord = undefined
	let prevChords = undefined
	for (let i = 0; i < sections.length; i++) {
		for (let j = 0; j < sections[i].bars.length; j++) {
			const chords = sections[i].bars[j]
			
			const clip = notesToClip(patternToBarPattern(pattern), chordsToChordsString(chords), prevChord)
			clips.push(clip)

			channelPattern += barCount + ','
			barCount++
			const notesArray = clip?.notes.split(' ')
			prevChord = prevChords === undefined ? undefined : prevChords[prevChords.length - 1] === '-' || notesArray === undefined ? undefined : notesArray[notesArray.length - 1]
			prevChords = chords
		}
	}
	
	const channelIdx = 'Synth'
	
	return {
		playPattern: {
			clipDuration: '1:0:0',
			channelPatterns: [{
				channelIdx: channelIdx,
				pattern: channelPattern.slice(0, channelPattern.length - 1)
			}]
		},
		channels: [{
			idx: channelIdx,
			clips,
			instrument: {
				name: 'AMSynth',
			}
		}]
	}
}

// const modesNames = Scale.modeNames('C major').map(modeName => modeName[1])// TODO : update modeName to full modeName (minor/major/etc) or only major / minor

const romanDegrees = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII']

const initialTimeSignature = { upper: 4, lower: 4 }

const BackingTrackGenerator = (props: {
	settings: any,
	onSettingsChange: (settings: any) => void,
	constants: any,
	setTitle: (title: string) => void
}) => {
	const {
		settings,
		onSettingsChange,
		constants,
		setTitle
	} = props
	
	// const [sections, dispatchSections] = useReducer(backingTrackGeneratorSectionsReducer, initialSectionsState)
	
	const [timeSignature, setTimeSignature] = useState(initialTimeSignature)
	
	const [projectName, setProjectName] = useState('Project 0')

	const [bpm, setBpm] = useState(120)
	
	const [editor, dispatchEditor] = useReducer(backingTrackGeneratorEditorReducer, initialEditorState)

	const inputRef = useRef<any>(undefined)
	
	console.log({ editor })

	const handlePlay = async () => {
		const { playPattern, channels } = generateBackingTrack(editor.sections, 'x[-x]x[xx]')
		
		scribbleUtils = await createScribbleUtils(channels)
		
		dispatchEditor({
			type: EditorActionType.Play
		})

		scribbleUtils.play(playPattern, (transportTime: string) => {
			console.log({ onProgress: transportTime, editor })

			dispatchEditor({
				type: EditorActionType.Progress,
				payload: {
					transportTime
				}
			})

			// TO CHECK : does it still work ?
			// setEditor((editor: any) => ({ ...editor, playingBarIndex: bar }))
		}, () => {
			console.log({ onComplete: editor })
			
			dispatchEditor({
				type: EditorActionType.Complete
			})
		})
	}

	const handleStop = () => {
		scribbleUtils.stop()
		console.log({ handleStop: editor })
		dispatchEditor({
			type: EditorActionType.Stop
		})
	}


	const handleExportProject = () => {
		var element = document.createElement('a')
		// TODO: only stringify editor object
		element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(JSON.stringify({
			name: projectName,
			config: {
				bpm,
				timeSignature
			},
			sections: editor.sections,
		}, null, '\t')))
		element.setAttribute('download', projectName + '.bt.json')

		element.style.display = 'none'
		document.body.appendChild(element)

		element.click()

		document.body.removeChild(element)
	}

	const handleImportProject = (e: any) => {
		const file = e.target.files[0]
		if (!file) {
			return
		}
		const reader = new FileReader()
		reader.onload = (e: any) => {
			const data = JSON.parse(e.target.result)

			// TODO : check if data is fine

			setProjectName(data.name)
			dispatchEditor({
				type: EditorActionType.Import,
				payload: {
					sections: data.sections
				}
			})

			handleChangeBpm(data.config.bpm)
		}
		reader.readAsText(file)
	}

	const handleChangeBpm = (bpm: number = 120) => {
		global.Tone.Transport.bpm.value = bpm
		setBpm(bpm)
	}



	const isDrag = editor.fakeChords !== undefined
	const [isDrag2, setIsDrag2] = useState(isDrag)
	// Use to prevent input select after drag (mouseUp being fire before mouseClick fakeChords will already been undefined)
	// FIXME : This is a workaround
	useEffect(() => { setTimeout(() => setIsDrag2(isDrag), DRAG_TIMEOUT) }, [isDrag])

	const handleClick = () => {

		console.log('backingT handleClick')
		
		if(editor.state.chordSelectedRanges.length > 0 && !isDrag2) {// fakeChords undefined mean we're not dragging
			console.log({ chordRanges: editor.state.chordSelectedRanges, fakeChords: editor.fakeChords })
			dispatchEditor({
				type: EditorActionType.ChordUnselect
			})
		}
		else if (editor.state.cursorRanges.length > 0)
			dispatchEditor({
				type: EditorActionType.CursorUnselect
			})
	}
	
	return (
		// <BackingTrackGeneratorSectionsContext.Provider value={[sections, dispatchSections]}>
			<BackingTrackGeneratorEditorContext.Provider value={[editor, dispatchEditor]}>
			
				<div id='backing-track-generator' onClick={handleClick}>
				
					<MyAppBar
						constants={constants}
						onSettingsChange={onSettingsChange}
						settings={settings}
					/>

					
					<MainControls
						projectName={projectName}
						onProjectNameChange={setProjectName}
						onPlay={handlePlay}
						onPause={() => null}
						onStop={handleStop}
						onLoadDemo={(demo: any) => null}
						isPlaying={editor.state.isPlaying}
						onExportProject={() => handleExportProject()}
						onImportProject={() => inputRef?.current?.click()}
					/>
					
					<BackingTrackEditor
						onPlayClick={(c) => ToneSound.playNotes(notesToChord(c.notes), settings.sound)}
						timeSignature={timeSignature}
					/>
					
					<input type='file' ref={inputRef} style={{ display: 'none' }} onChange={handleImportProject} />

				
				</div>
			
			</BackingTrackGeneratorEditorContext.Provider>
		// </BackingTrackGeneratorSectionsContext.Provider>
		)
	}
	
	export default BackingTrackGenerator
	
	// Présente + d'accord que themajor7 et + de root (C##) -> Meilleur algo de recherche de chord
	// Ajoute un système de section et une structure de morceau
	
	// TODO : Add structure component
	
	// TODO : filter & order chord autocomplete
	
	// TODO : Input, tab + enter to valid for - & _ or else